<template>
  <iDropdown
    :visible="visible"
    trigger="custom"
    placement="bottom-end"
    transfer
    class="gdl-dropdown"
    @on-click="onSelectedDropdown">
    <iButton
      type="text"
      shape="circle"
      size="small"
      @click="toggle()">
      <iIcon type="ios-gear"/>
      <iIcon
        type="arrow-down-b"
        style="margin-left: 5px"/>
    </iButton>
    <iDropdownMenu
      v-clickoutside="onClickOutside"
      slot="list"
      class="gdl-dropdown-list"
    >
      <template v-if="sorting">
        <draggable v-model="unsavedSelected">
          <iDropdownItem
            v-for="column in selectedColumns"
            v-show="column.title"
            :key="column.key"
            :name="column.key"
          >
            <span
              class="text-capitalize-first"
              v-text="column.title"/>
            <iIcon
              type="drag"
              style="float: right; margin-top: 2px;"/>
          </iDropdownItem>
        </draggable>
        <iDropdownItem
          name="gdl-select"
          divided
        >{{ $t('components.gdl.gdl_data_table.select') }}</iDropdownItem>
      </template>
      <template v-else>
        <iCheckboxGroup v-model="unsavedSelected">
          <iDropdownItem
            v-for="column in orderedColumns"
            v-if="column.title"
            :key="column.key"
            :name="column.key"
          >
            <iCheckbox
              :label="column.key"
              :disabled="isLastSelected(column.key)"
            >
              <span
                class="text-capitalize-first"
                v-text="column.title"/>
            </iCheckbox>
          </iDropdownItem>
        </iCheckboxGroup>
        <iDropdownItem
          v-if="deletable"
          divided
          name="gdl-deleted">
          <iCheckbox
            :value="showDeleted"
            @on-change="onShowDeletedChange"
          >
            <span v-t="'components.gdl.gdl_data_table.show_deleted'"/>
          </iCheckbox>
        </iDropdownItem>
        <iDropdownItem
          divided
          name="gdl-sort"
        >{{ $t('components.gdl.gdl_data_table.sort') }}</iDropdownItem>
      </template>
    </iDropdownMenu>
  </iDropdown>
</template>

<script>
import Vue from 'vue';
import { compact, keyBy, sortBy } from 'lodash';

import { latinize, toLower } from '@/lib/strings';

import Draggable from 'vuedraggable';
import clickoutside from 'iview/src/directives/clickoutside';

export default {
  name: 'GdlDataTableColumnsSelector',
  components: { Draggable },
  directives: { clickoutside },
  // filters: { filter },
  // mixins: [MyMixin],
  model: {
    prop: 'selected',
    event: 'change',
  },
  props: {
    columns: { type: Array, required: true },
    selected: { type: Array, default: () => [] },
    showDeleted: { type: Boolean, default: false },
    deletable: { type: Boolean, default: true },
  },
  data() {
    return {
      visible: false,
      sorting: false,
      unsavedSelected: this.selected,
      // hack avoid close right after open due to onClickOutside
      toggled: false,
    };
  },
  computed: {
    columsByKey() { return keyBy(this.columns, 'key'); },
    orderedColumns() { return sortBy(this.columns, ({ title }) => toLower(latinize(title))); },
    selectedColumns() {
      return compact(this.unsavedSelected.map(key => this.columsByKey[key]));
    },
  },
  watch: {
    selected() {
      this.unsavedSelected = this.selected;
    },
  },
  methods: {
    onShowDeletedChange(value) {
      this.$emit('show-deleted-change', value);
    },
    onSelectedDropdown(name) {
      if (name === 'gdl-sort') {
        this.sorting = true;
        this.reopen();
      } else if (name === 'gdl-select') {
        this.sorting = false;
        this.reopen();
      }
    },
    reopen() {
      this.visible = false;
      Vue.nextTick(() => { this.visible = true; });
    },
    toggle() {
      if (this.visible) this.close();
      else this.open();
    },
    open() {
      this.visible = true;
      this.toggled = true; // hack
    },
    close() {
      this.visible = false;
      this.toggled = false; // hack
      // hack
      if (this.$gdl_clearSorting) clearTimeout(this.$gdl_clearSorting);
      this.$gdl_clearSorting = setTimeout(() => {
        this.$emit('change', this.unsavedSelected);
        this.sorting = false;
        this.$gdl_clearSorting = undefined;
      }, 300);
    },
    onClickOutside() {
      if (!this.visible) return;
      if (this.toggled) { // hack
        this.toggled = false;
        return;
      }
      this.close();
    },
    isLastSelected(key) {
      if (this.unsavedSelected.length === 1 &&
        this.unsavedSelected.includes(key)) { return true; }
      return false;
    },
  },
};
</script>

<style scoped>
</style>
